import type { ReactNode } from 'react';

type BadgeStatus = 'success' | 'error' | 'neutral';

type BadgeProps = {
	children: ReactNode;
	status: BadgeStatus;
};

const statusMap: Record<BadgeStatus, string> = {
	success: 'bg-green-400',
	error: 'bg-rural-red-900 text-white',
	neutral: 'bg-rural-gray-200'
};

export default function Badge({
	children,
	status
}: BadgeProps ) {
	const statusClass = statusMap[ status ];

	return (
		<div className={ `inline-block ml-2 text-xs uppercase font-semibold py-0.5 px-2 ${ statusClass }` }>
			{ children }
		</div>
	);
}
